// extracted by mini-css-extract-plugin
export default {"mainInfo":"News_mainInfo__EOaNV","content":"News_content__GANyM","contentShrink":"News_contentShrink__5k7J3"};